import { useEffect } from 'react';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <a href="/" className="text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center gap-2">
            ← Back to V&V
          </a>
        </div>
        
        <div className="prose prose-invert max-w-none">
          <h1 className="text-4xl font-bold mb-4">Terms of Use</h1>
          <div className="flex gap-6 text-gray-400 text-sm mb-8 pb-4 border-b border-gray-800">
            <span>Effective: 1 January 2026</span>
            <span>Last updated: 1 January 2026</span>
            <span>Governing law: Republic of Kenya</span>
          </div>
          
          <div className="bg-blue-500/10 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-300">
              These Terms of Use govern your access to and use of the Vett & Venture website and all associated platform features. By accessing or using the Platform, you agree to be bound by these Terms.
            </p>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Use of the Website</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            You may use the V&V website for lawful purposes only. You agree not to use the website in any way that is unlawful, fraudulent, or harmful. You must not attempt to gain unauthorised access to any part of the Platform.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Intellectual Property</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            All content on this website — including text, graphics, logos, and the V&V brand — is the exclusive property of Vett & Venture Studio Limited. V&V's proprietary methodology, including the Problem Bank framework, Scalar Criteria, and Forge programme design, is protected intellectual property.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Account Registration</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            To access the Forge, anchor platform, or Fix-and-Deliver Hub, you must create an account. You are responsible for maintaining the confidentiality of your login credentials.
          </p>
          
          <div className="bg-red-500/10 border-l-4 border-red-500 p-6 rounded-r-lg mt-8 mb-8">
            <strong className="text-red-400">Misrepresentation:</strong> Submitting false application data or fabricated company information constitutes a material breach and may result in permanent exclusion.
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Governing Law</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            These Terms are governed by the laws of the Republic of Kenya. Any dispute shall be subject to the exclusive jurisdiction of the Kenyan courts.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Contact</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            For questions about these Terms, contact us at <a href="mailto:legal@vettandventure.com" className="text-blue-400 hover:underline">legal@vettandventure.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;